import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ProductCard } from '../components/ProductCard';
import { products, Season, ProductCategory } from '../data/products';
export function Category() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  // Map slugs to category data
  const categoryMap: Record<string, {
    title: string;
    desc: string;
    filter: (p: any) => boolean;
  }> = {
    'lawn-mowers': {
      title: 'Yarbo Robotic Lawn Mowers for Michigan Properties',
      desc: 'Wire-free, autonomous mowing for standard yards up to demanding 6-acre properties with steep slopes.',
      filter: p => p.season.includes('Lawn Care') && (p.category === 'Complete Systems' || p.category === 'Modules')
    },
    'snow-blowers': {
      title: 'Yarbo Robotic Snow Blowers for Michigan Winters',
      desc: 'True 2-stage autonomous snow clearing built to handle heavy lake-effect snow and long driveways.',
      filter: p => p.season.includes('Snow Removal') && (p.category === 'Complete Systems' || p.category === 'Modules')
    },
    'leaf-blowers': {
      title: 'Yarbo Robotic Leaf Blowers & Debris Cleanup',
      desc: 'High-force blowing power to keep wooded Michigan lots clear of leaves and debris all fall.',
      filter: p => p.season.includes('Leaf Cleanup') && (p.category === 'Complete Systems' || p.category === 'Modules')
    },
    bundles: {
      title: 'Yarbo Bundles for All-Season Yard Care',
      desc: 'Maximize your Yarbo Core with multi-season bundles. Tackle snow, grass, and leaves with one intelligent system.',
      filter: p => p.category === 'Bundles'
    },
    'modules-accessories': {
      title: 'Yarbo Modules & Accessories',
      desc: 'Expand your existing Yarbo Core with new seasonal modules or upgrade your setup with official accessories.',
      filter: p => p.category === 'Modules' || p.category === 'Accessories'
    }
  };
  const categoryData = categoryMap[slug || ''];
  if (!categoryData) {
    return <Navigate to="/shop" replace data-id="element-162" />;
  }
  const categoryProducts = products.filter(categoryData.filter);
  return <div className="bg-gray-50 min-h-screen py-12" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="mb-12 text-center max-w-4xl mx-auto" data-id="element-165">
          <motion.h1 initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-3xl md:text-5xl font-extrabold text-yarbo-dark mb-6" data-id="element-166">
            {categoryData.title}
          </motion.h1>
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-600" data-id="element-167">
            {categoryData.desc}
          </motion.p>
        </div>

        {categoryProducts.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-168">
            {categoryProducts.map((product, idx) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} data-id="element-169">
                <ProductCard product={product} data-id="element-170" />
              </motion.div>)}
          </div> : <div className="text-center py-20" data-id="element-171">
            <p className="text-gray-500" data-id="element-172">No products found in this category.</p>
          </div>}
      </div>
    </div>;
}